import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const OverviewSkeleton = () => {
  return (
    <>
      <div className={tw`grid grid-cols-5 gap-x-4 justify-center items-center`}>
        {Array.from({ length: 4 }).map((_, index: number) => {
          return (
            <div
              key={index}
              className={tw`w-full bg-gray-200 animate-pulse h-20 rounded-md mb-8 cursor-pointer focus:outline-none text-left`}
              style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
            ></div>
          );
        })}
      </div>
      <div
        className={tw`w-full bg-gray-200 animate-pulse h-4/6 rounded-md mb-8 cursor-pointer focus:outline-none text-left`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      ></div>
    </>
  );
};

export default OverviewSkeleton;
